import { debounce } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import draftmanJobApi from '../../APIs/draftman';
import techniciansJobApi from '../../APIs/technicians';
import {
  Button,
  PageHeader,
  Pagination,
  Table,
  Tabs,
  Tag,
} from '../../designComponents';
import { TableDataType } from '../../designComponents/Table';
import { ADD_JOBS_ROUTE, VIEW_JOBS_ROUTE } from '../../routes/routePaths';
import Store from '../../store';
import { RootState } from '../../store/selectors';
import theme from '../../theme';
import {
  humanReadableDate,
  humanReadableDateWithTime,
  requestAPI,
} from '../../utils';
import { MyParamsType } from '../Building';
import { JobsListingContainerStyled } from './style';

type ParamsType = {
  page: number;
  limit: number;
};

type TabType = {
  key: string;
  label: string;
  role: string;
};

export type TechnicianJobType = {
  _id: string;
  jobTitle: string;
};

const tabs: TabType[] = [
  {
    key: 'technician',
    label: 'Technician',
    role: 'technician',
  },
  // {
  //   key: 'draftMan',
  //   label: 'DraftMan',
  //   role: 'draftman',
  // },
  // {
  //   key: 'escPlan',
  //   label: 'Escape Plan',
  //   role: 'escPlan',
  // },
  // {
  //   key: 'printer',
  //   label: 'Printer',
  //   role: 'printer',
  // },
];

const CreateJobs = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const activeTab: string = useSelector(Store.Selectors.createJobsActiveTab);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const pagination = useSelector(
    (state: RootState) => state.technicianJobs.pagination,
  );

  const technicianJobs = useSelector(
    (state: RootState) => state.technicianJobs.data,
  );

  const draftmanJobs = useSelector(
    (state: RootState) => state.draftmanJobsData.data,
  );

  const getAllDraftManJobs = async () => {
    try {
      setLoading(true);
      await requestAPI(draftmanJobApi.getAllDraftmanJob());
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.error(error);
      toast.error(error);
    }
  };

  const handleGetTehnicianJobs = async (myParams: MyParamsType) => {
    try {
      setLoading(true);
      await requestAPI(
        techniciansJobApi.getTechnicianJobs({
          page: myParams.page,
          limit: myParams.limit,
          search: myParams.search ? myParams.search : '',
        }),
      );
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };
  const debouncedFunction = useCallback(
    debounce((myParams) => handleGetTehnicianJobs(myParams), 500),
    [],
  );
  useEffect(() => {
    handleGetTehnicianJobs(pagination);
    getAllDraftManJobs();
  }, []);

  const formatDraftmanTableData = () => {
    return draftmanJobs?.map((draft) => ({
      id: `${draft?._id}`,
      createdDate: humanReadableDateWithTime(draft?.createdAt),
      jobTitle: draft?.title,
      price: draft?.pricingPlan?.price,
      currency: draft?.pricingPlan?.priceDenom,
      shippingAddress: draft?.shippingAddress,
      status: <Tag style={{ padding: '0px 10px' }}>{draft?.status}</Tag>,
      style: {
        status: { textAlign: 'center' },
      },
      actions: (
        <Button
          variant="secondary"
          size="md"
          onClick={() =>
            navigate(
              VIEW_JOBS_ROUTE.replace(
                ':jobFor',
                tabs.find((x: TabType) => x.key === activeTab)?.role || '',
              ).replace(':jobId', `${draft?._id}`),
            )
          }
          style={{
            backgroundColor: theme.colors.blueLight,
            border: `1px solid ${theme.colors.blueLight}`,
          }}
        >
          View Details
        </Button>
      ),
    }));
  };
  const tableDataForPrinter: TableDataType = {
    headings: [
      {
        key: 'createdDate',
        label: 'Date',
      },
      {
        key: 'pdfName',
        label: 'PDF Name',
      },
      {
        key: 'quantity',
        label: 'Print Quantity',
      },
      {
        key: 'notes',
        label: 'Notes',
      },
      {
        key: 'status',
        label: 'Status',
        style: {
          textAlign: 'center',
        },
      },
      {
        key: 'actions',
        label: 'Action',
      },
    ],

    body: [
      {
        id: '1',
        createdDate: '12 aug 2023 - 12:59 am',
        pdfName: 'Evacuation plan for hotel',
        quantity: 1,
        notes:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id aliquet sem. Quisque lectus metus, ullamcorper a ullamcorper vitae, molestie quis elit. Pellentesque condimentum tellus metus, eget facilisis ex fringilla nec. In efficitur augue quis egestas tincidunt. Mauris vel leo dapibus nunc imperdiet finibus. Nam at magna quis elit tempus iaculis vel id ligula. Maecenas id fermentum felis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras id faucibus orci, eu porta sem. Aenean ultrices erat et nisl suscipit, a placerat ipsum feugiat. Integer gravida odio dui, sit amet efficitur ligula laoreet non.',
        status: <Tag style={{ padding: '0px 10px' }}>Active</Tag>,
        style: {
          status: { textAlign: 'center' },
        },
        actions: (
          <Button
            variant="secondary"
            size="md"
            onClick={() =>
              navigate(
                VIEW_JOBS_ROUTE.replace(
                  ':jobFor',
                  tabs.find((x: TabType) => x.key === activeTab)?.role || '',
                ).replace(':jobId', '1'),
              )
            }
            style={{
              backgroundColor: theme.colors.blueLight,
              border: `1px solid ${theme.colors.blueLight}`,
            }}
          >
            View Details
          </Button>
        ),
      },
      {
        id: '2',
        createdDate: '12 aug 2023 - 12:59 am',
        pdfName: 'Evacuation plan for hotel',
        quantity: 8,
        notes:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam id aliquet sem. Quisque lectus metus, ullamcorper a ullamcorper vitae, molestie quis elit. Pellentesque condimentum tellus metus, eget facilisis ex fringilla nec. In efficitur augue quis egestas tincidunt. Mauris vel leo dapibus nunc imperdiet finibus. Nam at magna quis elit tempus iaculis vel id ligula. Maecenas id fermentum felis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras id faucibus orci, eu porta sem. Aenean ultrices erat et nisl suscipit, a placerat ipsum feugiat. Integer gravida odio dui, sit amet efficitur ligula laoreet non.',
        status: <Tag style={{ padding: '0px 10px' }}>Active</Tag>,
        actions: (
          <Button
            variant="secondary"
            size="md"
            onClick={() =>
              navigate(
                VIEW_JOBS_ROUTE.replace(
                  ':jobFor',
                  tabs.find((x: TabType) => x.key === activeTab)?.role || '',
                ).replace(':jobId', '1'),
              )
            }
            style={{
              backgroundColor: theme.colors.blueLight,
              border: `1px solid ${theme.colors.blueLight}`,
            }}
          >
            View Details
          </Button>
        ),
        style: {
          status: { textAlign: 'center' },
        },
      },
    ],
  };
  const tableDataForDraftMan: TableDataType = {
    headings: [
      {
        key: 'createdDate',
        label: 'Date',
      },
      {
        key: 'jobTitle',
        label: 'Job Title',
      },
      {
        key: 'currency',
        label: 'Currency',
      },
      {
        key: 'price',
        label: 'Price',
      },
      {
        key: 'shippingAddress',
        label: 'Shipping Address',
      },
      {
        key: 'status',
        label: 'Status',
        style: {
          textAlign: 'center',
        },
      },
      {
        key: 'actions',
        label: 'Action',
      },
    ],

    body: formatDraftmanTableData(),
  };

  const handleOnSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearch(value);
    debouncedFunction({ ...pagination, page: 1, search: value });
  };

  const handlePagination = (updatedParams: ParamsType) => {
    handleGetTehnicianJobs(updatedParams);
    dispatch(Store.Actions.update('technicianJobs.pagination', updatedParams));
  };

  const handleOnTabsChange = (key: string) => {
    dispatch(Store.Actions.set('createJobsActiveTab', key));
  };

  const handleAddJobs = () =>
    navigate(
      ADD_JOBS_ROUTE.replace(
        ':jobFor',
        tabs.find((x: TabType) => x.key === activeTab)?.role || '',
      ),
    );

  const tableData: TableDataType = {
    headings: [
      {
        key: 'createdDate',
        label: 'Date',
      },
      {
        key: 'jobTitle',
        label: 'Job Title',
      },
      {
        key: 'buildingName',
        label: 'Building Name',
      },
      {
        key: 'buildingAddress',
        label: 'Building Address',
      },

      {
        key: 'actions',
        label: 'Action',
      },
    ],

    body: Array.isArray(technicianJobs)
      ? technicianJobs.map((technician) => {
        return {
          createdDate: humanReadableDate(technician.createdAt),
          id: technician._id,
          jobTitle: technician.jobTitle,
          buildingName: technician.building.buildingName,
          buildingAddress: technician.building.buildingAddress,
          createdBy: technician.createdBy.fullName,
          actions: (
              <Button
                variant="secondary"
                size="md"
                isLoading={loading}
                onClick={() =>
                  navigate(
                    VIEW_JOBS_ROUTE.replace(
                      ':jobFor',
                      tabs.find((x: TabType) => x.key === activeTab)?.role || '',
                    ).replace(':jobId', technician._id),
                  )
                }
                style={{
                  backgroundColor: theme.colors.blueLight,
                  border: `1px solid ${theme.colors.blueLight}`,
                }}
              >
                View Details
              </Button>
          ),
        };
      })
      : [],
  };

  return (
    <JobsListingContainerStyled>
      <PageHeader
        maxWidthBreakPoint="768px"
        pageTitle={
          <Tabs
            activeKey={activeTab}
            items={tabs}
            onChange={handleOnTabsChange}
            transparentBackground={false}
          />
        }
        otherActions={
          <Button variant="secondary" size="sm" onClick={handleAddJobs}>
            <FaPlus /> Create Job
          </Button>
        }
        handleOnSearchTextChange={handleOnSearchTextChange}
        search={search}
      />
      <div className="table-container">
        {
          {
            printer: <Table tableData={tableDataForPrinter} />,
            technician: <Table tableData={tableData} isLoading={loading} />,
            draftMan: (
              <Table tableData={tableDataForDraftMan} isLoading={loading} />
            ),
          }[activeTab]
        }
      </div>
      <Pagination
        activePage={pagination.page}
        handlePagination={handlePagination}
        limit={pagination.limit}
        totalCount={pagination.totalData || 0}
      />
    </JobsListingContainerStyled>
  );
};

export default CreateJobs;
